import styled from 'styled-components';

import {
  AccessTimeOutlined,
  AutoAwesomeOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import { Box, Chip, Tooltip as MuiTooltip } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

import { FilterInput } from 'components';

export const ChatListRoot = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  position: absolute;
  border-right: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
`;

export const ChatListHeader = styled.header`
  margin: ${({ theme }) =>
    `${theme.yoga.spacing.xlarge}px ${theme.yoga.spacing.large}px  ${theme.yoga.spacing.zero}px ${theme.yoga.spacing.medium}px`};

  & .align-left {
    justify-content: left;
  }
`;

export const ChatListHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => `${theme.yoga.spacing.large}px`};

  @media screen and (max-width: 1024px) {
    margin-top: ${wellzTheme.spacing(0)};
    padding-bottom: ${wellzTheme.spacing(1)};
  }
`;

export const ChatListHeaderDivider = styled.hr`
  width: 100%;
  border-width: 0px 0px 1px;
  border-color: rgb(215, 215, 224);
  margin: ${({ theme }) => `${theme.yoga.spacing.zero}px`};
`;

export const ArrowButton = styled.button`
  border: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: transparent;
  padding: 0;
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const ChatListTabs = styled.nav`
  display: flex;
`;

export const ChatListTab = styled.div<{ isSelected: boolean }>`
  flex-basis: 100%;
  text-align: center;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.large}px;
  border-bottom: ${({ isSelected, theme }) =>
    isSelected
      ? `${theme.yoga.borders.medium}px solid ${theme.yoga.colors.primary}`
      : `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
  cursor: ${({ isSelected }) => (isSelected ? 'default' : 'pointer')};

  > p {
    color: ${({ isSelected, theme }) =>
      isSelected ? theme.yoga.colors.primary : theme.yoga.colors.textSecondary};
  }
`;

export const ChatListContainer = styled.ul<{ hasListTabs: boolean }>`
  overflow-y: auto;
  height: ${({ hasListTabs }) =>
    `calc(100vh - ${hasListTabs ? '205px' : '163px'})`};
`;

export const PatientNameInput = styled(props => <FilterInput {...props} />)`
  margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const HeaderActions = styled(Box)`
  margin-bottom: ${wellzTheme.spacing(2)};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${wellzTheme.spacing(1)};
`;

export const MessageTipsIcon = styled(AutoAwesomeOutlined)`
  width: ${wellzTheme.spacing(2.25)};
  height: ${wellzTheme.spacing(2.25)};
  fill: ${wellzTheme.palette.primary.main};
  margin-right: ${wellzTheme.spacing(1)};
`;

export const IconLegendIcon = styled(InfoOutlined)`
  fill: ${wellzTheme.palette.primary.main};
  height: ${wellzTheme.spacing(2.5)};
  width: ${wellzTheme.spacing(2.5)};

  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

export const ScheduledMessageIcon = styled(AccessTimeOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.info.main};
`;

export const CriticalityIcon = styled(WarningAmberOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.error.main};
`;

export const UnlinkIcon = styled(InfoOutlined)`
  width: ${wellzTheme.spacing(2)};
  height: ${wellzTheme.spacing(2)};
  fill: ${wellzTheme.palette.warning.main};
`;

export const Tooltip = styled(MuiTooltip).attrs({
  slotProps: {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 16],
          },
        },
      ],
    },
    tooltip: {
      sx: {
        backgroundColor: wellzTheme.palette.background.default,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        padding: 0,
        paddingRight: wellzTheme.spacing(2),
      },
    },
  },
})``;

export const SelectableFiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${wellzTheme.spacing(1)};
  margin: ${wellzTheme.spacing(2, 0, 0.5, 3)};
`;

export const SelectedFilterChip = styled(Chip).attrs({ color: 'primary' })`
  & .MuiChip-label {
    color: ${wellzTheme.palette.primary.contrastText};
  }
`;
